import React, { useEffect, useState, useContext } from "react";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import { CSS_CLASSES } from "../../../../../../css-classes";
import { useSelector } from "react-redux";
import { NavLink, useNavigate } from "react-router-dom";
import Popup from "../../../../../popup/Popup";
import { ThemeModeContext } from "../../../../../ThemeMode/Context";
import { MdArrowDropDown } from "react-icons/md";
import useHandleGameClick from "../../../../useHandleGameClick/useHandleGameClick";
const initSetting = {
  provider_grid: null,
  class: null,
  default_class: null,
};

const GameProvider = (props) => {
  const [fnSetting, setFnSetting] = useState(initSetting);
  const { themeMode } = useContext(ThemeModeContext);
  const [isCardLoading, setIsCardLoading] = useState(true);
  const [clickedGame, setClickedGame] = useState(null);
  const [launchGameDetails, setLaunchGameDetails] = useState({});
  const deviceType = localStorage.getItem("device_type");

  const {
    apiResponseError,
    maintainanceError,
    commingSoonPopup,
    isgameplayerPopup,
    gameLaunchMessage,
    handlePopup,
    userDataHandle,
    HandleGamePlayer,
    confirmRelaunch,
    cancelRelaunch,
  } = useHandleGameClick(props, setIsCardLoading, setClickedGame, launchGameDetails);
  const navigate = useNavigate();
  const code = window.location.pathname.substring(1);
  const showAllProvider = () => navigate("/game-provider");
  const [providerList, setProviderList] = useState([]);
  let { providerSubMenuList, componentSetting } = useSelector((state) => ({
    providerSubMenuList: state.submenuListR.data,
    componentSetting: state.componentSettingListR.data,
  }));

  useEffect(() => {
    if (componentSetting?.["game-provider"]) {
      setFnSetting((prev) => ({
        ...prev,
        provider_grid: componentSetting["game-provider"]["default-value"],
        default_class: componentSetting["game-provider"]["default-value"],
        game_provider_handle: componentSetting.custom_loading?.options?.game_provider_handle,
      }));
    }
  }, [componentSetting]);

  const mainTainProviderName = (record) => {
    if (record?.tenant_provider_reco) {
      localStorage.setItem("provider_name", record.tenant_provider_reco.provider_name);
    }
  };

  useEffect(() => {
    const status = localStorage.getItem("all_game_click");
    if (!Object.keys(providerSubMenuList).length)
      return;
    setProviderList(providerSubMenuList);
    if (status) window.scrollTo(0, 350);
    if (deviceType == 'mobile' && code != 'game-provider') {
      let newList = providerSubMenuList?.slice(0, 24);
      setProviderList(newList);
    }
  }, [providerSubMenuList, themeMode]);

  return (
    <>
      <div className="game-provider grid-inner" >
        <div className="container">
          {fnSetting["game_provider_handle"] && (
            <div className="game-header">
              <div className="title text-providersgame-carousel text-section_heading">{props.t("game_providers")}</div>
            </div>
          )}
          {fnSetting["provider_grid"] && (
            <div className="game-provider-wrapper">
              {fnSetting["game_provider_handle"] &&
                (
                  <div className={"game-provider-grid"}>
                    <div className={CSS_CLASSES.menuItemsHover}>
                      {providerList.length > 0 &&
                        providerList.map((obj) => (
                          <React.Fragment key={obj._id}>
                            <div className="under-games">
                              <NavLink
                                key={obj}
                                onClick={() => mainTainProviderName(obj)}
                                to={
                                  obj?.menu_code === "lottery"
                                    ? `lotteryHome/${obj?.url_slug || obj?.main_provider?.url_slug}`
                                    : `/${obj?.url_slug || obj?.main_provider?.url_slug}`
                                }
                                state={{
                                  extraData: obj?.provider_name ? obj?.provider_name : obj?.alias,
                                }}
                              >
                                <div className="item">
                                  <img
                                    loading="lazy"
                                    className="img-fluid"
                                    src={
                                      obj?.provider_media
                                        ? `${obj.ftp_path}${obj.provider_media.base_path}${obj.provider_media.system_file_name}`
                                        : obj?.path || '/assets/images/default-images/providersm.webp'
                                    }
                                    alt={
                                      obj?.provider_media?.extra_param?.alternate ||
                                      obj?.main_provider?.provider_name
                                    }
                                    width="60"
                                    height="60"
                                  />
                                </div>
                              </NavLink>
                            </div>
                          </React.Fragment>
                        ))}
                    </div>
                  </div>
                )}
            </div>
          )}
          <div className="game-header">
            {code !== "game-provider" && (
              <div className="sub-header text-see_all border-see_all" onClick={showAllProvider}>
                {props.t("see_all")}<MdArrowDropDown />
              </div>
            )}
          </div>
        </div>
      </div>
      {isgameplayerPopup && (
        <Popup
          handlePoup={HandleGamePlayer}
          playerstatus
          userDataHandle={userDataHandle}
        />
      )}
      {maintainanceError && (
        <Popup handlePoup={handlePopup} providerMaintainance />
      )}
      {gameLaunchMessage && (
        <Popup handlePoup={handlePopup} launchGameMessage confirmRelaunch={confirmRelaunch} cancelRelaunch={cancelRelaunch} />
      )}

      {commingSoonPopup && <Popup handlePoup={handlePopup} commingSoonGame />}

      {apiResponseError && (
        <Popup handlePoup={handlePopup} apiresponseerror />
      )}

    </>
  );
};

GameProvider.propTypes = {
  preGlobalFilteredRows: PropTypes.any,
};

export default withTranslation()(GameProvider);
